<template>
  <div class="mt-4">
    <!-- <h2 class="font-bold text-xl mb-6">SMS</h2> -->
    <div class="flex">
      <div class="w-1/2 pr-6"><SMSForm /></div>
      <div class="w-1/2 pl-6">
        <SmsPreview />
      </div>
    </div>

    <base-button type="success">Submit</base-button>
  </div>
</template>
<script>
import SMSForm from "./SMSForm";
import SmsPreview from "./SmsPreview";
export default {
  data() {
    return {
      key: value,
    };
  },
  components: {
    SmsPreview,
    SMSForm,
  },
};
</script>
